<div class="post d-flex flex-column-fluid">
  <div class="container">
    <div class="card" style="margin-top: 15px; height: 97vh;">
      <div class="card-body p-0 esign-container">
        <div class="card-px py-20 my-10">
          @switch (status) {
            @case ('reporting') {
              <div class="alert bg-light-primary border border-primary border-dashed d-flex flex-column flex-sm-row w-100 p-5 mb-10">
                <i class="fas fa-spinner fa-spin fa-3x text-primary me-4 mb-3 mb-sm-0"></i>
                <div class="d-flex flex-column pe-0 pe-sm-10">
                  <h4 class="mb-2 text-primary fw-bold">Recording Your Response...</h4>
                  <span class="text-gray-700">Please wait while we record the result of this signing session.</span>
                </div>
              </div>
            }
            @case ('signed') {
              <div class="alert bg-light-success border border-success border-dashed d-flex flex-column flex-sm-row w-100 p-5 mb-10">
                <i class="fas fa-check-circle fa-3x text-success me-4 mb-3 mb-sm-0"></i>
                <div class="d-flex flex-column pe-0 pe-sm-10">
                  <h4 class="mb-2 text-success fw-bold">Document Signed Successfully!</h4>
                  <span class="text-gray-700">Your eSignature has been submitted and the document signing process is complete.</span>
                </div>
              </div>
            }
            @case ('declined') {
              <div class="alert bg-light-warning border border-warning border-dashed d-flex flex-column flex-sm-row w-100 p-5 mb-10">
                <i class="fas fa-ban fa-3x text-warning me-4 mb-3 mb-sm-0"></i>
                <div class="d-flex flex-column pe-0 pe-sm-10">
                  <h4 class="mb-2 text-warning fw-bold">Signing Declined</h4>
                  <span class="text-gray-700">You declined to sign this document. Nothing was signed, and the declined response has been recorded.</span>
                </div>
              </div>
            }
            @case ('cancelled') {
              <div class="alert bg-light-warning border border-warning border-dashed d-flex flex-column flex-sm-row w-100 p-5 mb-10">
                <i class="fas fa-circle-xmark fa-3x text-warning me-4 mb-3 mb-sm-0"></i>
                <div class="d-flex flex-column pe-0 pe-sm-10">
                  <h4 class="mb-2 text-warning fw-bold">Signing Cancelled</h4>
                  <span class="text-gray-700">This signing session ended before the document was signed. You can start it again from the task.</span>
                </div>
              </div>
            }
            @case ('notRecorded') {
              <div class="alert bg-light-danger border border-danger border-dashed d-flex flex-column flex-sm-row w-100 p-5 mb-10">
                <i class="fas fa-triangle-exclamation fa-3x text-danger me-4 mb-3 mb-sm-0"></i>
                <div class="d-flex flex-column pe-0 pe-sm-10">
                  <h4 class="mb-2 text-danger fw-bold">We Couldn't Record This Signing Session</h4>
                  <span class="text-gray-700">The signing session ended, but its result could not be recorded. Please close this window and check the task before signing again.</span>
                </div>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>
